// The type ramp اعتبار is drawn with.
//
// These are not new sizes. They are the values this app already spells out
// inline on every screen ('0.8125rem' body, '0.6875rem' caption, '0.75rem'
// label) — and they are byte-identical to the doctor client's
// src/constants/typography.js, which is what makes the two panels' credit
// surfaces the same design rather than two things that resemble each other.
// اعتبار needs ~60 of them on one screen, and sixty inline literals is where a
// ramp starts to drift.
//
// FONT FAMILY IS ABSENT ON PURPOSE. styles.css declares one «Meshkat»
// (Vazirmatn) face on html/body and everything inherits it; a component-level
// `fontFamily` is a defect (DESIGN-CONCEPT-MOBILE §2.1, and
// tests/mobileComposition.test.js fails on one).
//
// SIZES ARE rem, never px, so they follow the dentist's font-size preference —
// tokens.css drives the root size off `data-font-size`, which is what the
// appearance picker on پروفایل writes.
//
// Usage: spread a role, then layer only colour and margins on top.
//   <div style={{ ...type.title, color: C.textPrimary }}>عنوان</div>
export const type = {
  // Headline number — the balance on the desktop hero.
  hero: { fontSize: '2.25rem', fontWeight: 800, lineHeight: 1.05 }, // ≈36px
  // The same number on a phone, where 36px would push the tiles off-screen.
  display: { fontSize: '1.625rem', fontWeight: 800, lineHeight: 1.1 }, // ≈26px
  // KPI / stat value.
  metric: { fontSize: '1.1875rem', fontWeight: 800, lineHeight: 1.2 }, // ≈19px
  // Card / section headings.
  title: { fontSize: '0.9375rem', fontWeight: 800, lineHeight: 1.3 }, // ≈15px
  // Numeric amounts (ledger rows, group totals).
  amount: { fontSize: '0.875rem', fontWeight: 800, lineHeight: 1.2 }, // ≈14px
  // Primary body / row text.
  body: { fontSize: '0.8125rem', fontWeight: 700, lineHeight: 1.4 }, // ≈13px
  // Field / stat labels.
  label: { fontSize: '0.75rem', fontWeight: 600, lineHeight: 1.4 }, // ≈12px
  // Secondary meta.
  caption: { fontSize: '0.6875rem', fontWeight: 600, lineHeight: 1.4 }, // ≈11px
  // Tiny meta / dot labels.
  micro: { fontSize: '0.625rem', fontWeight: 700, lineHeight: 1.4 }, // ≈10px
  // Unit suffix («پارسه»), beside a value in a lighter weight.
  unit: { fontSize: '0.75rem', fontWeight: 700 }, // ≈12px
};

export default type;
